import { render, staticRenderFns } from "./IntakeFollowUp.vue?vue&type=template&id=a81c0d90&scoped=true&"
import script from "./IntakeFollowUp.vue?vue&type=script&lang=js&"
export * from "./IntakeFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./IntakeFollowUp.vue?vue&type=style&index=0&id=a81c0d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81c0d90",
  null
  
)

export default component.exports